'use client'

import { CartItemPaymentWarning } from '@/feature/cart-item/components/cart-item-payment-warning/CartItemPaymentWarning.client'
import { QuantityPicker } from '@/ui/form/inputs/quantity-picker/QuantityPicker.client'
import { twMerge } from '@/lib/classname/twMerge'
import { EquivalentProductsLink } from '../../equivalent-products/EquivalentProductsLink.client'
import { ProductPrice } from '../../product-price/ProductPrice.client'
import {
  type ProductRowPriceProps,
  ProductRowSource,
  type ProductRowSourceProp,
} from '../ProductRow.client'
import { ProductRowSkeletons } from './ProductRowSkeletons'

export function ProductRowPrice({
  source,
  isLoadingPriceAndStocks,
  product,
  discount,
  totalExclTax,
  unitPrice,
  displaySavedAmount,
  displayEquivalentProducts,
  displayPaymentWarning,
  displayReadOnlyQuantity,
  displayQuantityPicker,
  isLoading,
  isDisabled,
  quantity,
}: ProductRowPriceProps & ProductRowSourceProp) {
  const packaging = product.stock?.packaging

  const isInMiniCart = source === ProductRowSource.MINI_CART

  return (
    <div
      className={twMerge(
        'flex shrink-0 flex-col items-start gap-0.5 leading-light desktop-md:w-22 desktop-md:items-end',
        isInMiniCart ? 'items-end' : discount?.percentage ? 'justify-start' : 'justify-center',
      )}
      data-testid="cart-item/details"
    >
      {/* Prices */}
      <div className="grow-1 flex flex-col items-end" data-testid="cart-item/price">
        {isLoadingPriceAndStocks ? (
          <ProductRowSkeletons.Prices />
        ) : (
          <ProductPrice
            size="2xl"
            type={product.type}
            price={totalExclTax || 0}
            discount={{
              price: (discount?.catalogDiscountAmount || 0) + (discount?.webDiscount?.amount || 0),
              percentage: discount?.percentage || 0,
            }}
            cartItemDiscount={discount}
            unitPrice={unitPrice?.exclTax || undefined}
            packaging={packaging}
            className="flex flex-col justify-items-start desktop-md:items-end desktop-md:justify-items-end"
            wrapperClassName="w-full flex-col items-start desktop-md:items-end"
            displaySavedAmount={displaySavedAmount}
            source={source}
          />
        )}
      </div>
      {product.urlKey && displayEquivalentProducts && (
        <EquivalentProductsLink slug={product.urlKey} />
      )}
      {displayPaymentWarning && <CartItemPaymentWarning isDisabled={isLoading || isDisabled} />}
      {displayReadOnlyQuantity && !displayQuantityPicker && isInMiniCart && (
        <QuantityPicker isReadOnly value={quantity} />
      )}
    </div>
  )
}
